/* Comfee Dawn - varyant seçimi, galeri ve sepet formu yardımcıları */
(function () {
  'use strict';

  function bindOnce(element) {
    if (element.dataset.comfeeBound === 'true') return false;
    element.dataset.comfeeBound = 'true';
    return true;
  }

  function parseJSONAttribute(value) {
    try {
      return JSON.parse(value || '[]');
    } catch (e) {
      return [];
    }
  }

  function updateButton(form, variant) {
    var button = form.querySelector('[data-add-button]');
    if (!button) return;
    button.disabled = !variant || !variant.available;
    button.textContent = variant && variant.available ? button.dataset.labelAvailable : button.dataset.labelSoldOut;
  }

  /* Tek açılır listeyle varyant seçimi (anasayfa vitrini, basit ürün bölümü) */
  function initVariantPickers() {
    var pickers = document.querySelectorAll('[data-variant-picker]');

    pickers.forEach(function (picker) {
      var form = picker.closest('form');
      if (!form || !bindOnce(picker)) return;

      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = document.getElementById(picker.dataset.priceTarget);
      var variants = parseJSONAttribute(picker.dataset.variants);

      picker.addEventListener('change', function () {
        var selected = variants.filter(function (variant) {
          return String(variant.id) === String(picker.value);
        })[0];

        if (!selected) return;
        if (idInput) idInput.value = selected.id;
        if (priceEl && selected.price_formatted) priceEl.textContent = selected.price_formatted;
        updateButton(form, selected);
      });
    });
  }

  /* Seçenek bazlı varyant seçimi (ürün sayfası: renk yuvarlakları ve listeler) */
  function initOptionPickers() {
    var pickers = document.querySelectorAll('[data-option-picker]');

    pickers.forEach(function (picker) {
      var form = picker.closest('form');
      if (!form || !bindOnce(picker)) return;

      var variants = parseJSONAttribute(picker.dataset.variants);
      var idInput = form.querySelector('[data-variant-id]');
      var priceEl = form.querySelector('[data-price]');
      var compareEl = form.querySelector('[data-price-compare]');

      function selectedOptions() {
        var values = [];
        picker.querySelectorAll('[data-option-index]').forEach(function (input) {
          var index = parseInt(input.dataset.optionIndex, 10);
          if (input.type === 'radio') {
            if (input.checked) values[index] = input.value;
          } else {
            values[index] = input.value;
          }
        });
        return values;
      }

      picker.addEventListener('change', function () {
        var values = selectedOptions();

        var match = variants.filter(function (variant) {
          return variant.options.every(function (option, index) {
            return option === values[index];
          });
        })[0];

        if (!match) {
          updateButton(form, null);
          return;
        }

        if (idInput) idInput.value = match.id;
        if (priceEl) priceEl.textContent = match.price_formatted;

        if (compareEl) {
          if (match.has_compare) {
            compareEl.textContent = match.compare_formatted;
            compareEl.removeAttribute('hidden');
          } else {
            compareEl.setAttribute('hidden', 'hidden');
          }
        }

        updateButton(form, match);
      });
    });
  }

  /* Galeri küçük görselleri */
  function initGallery() {
    var thumbs = document.querySelectorAll('[data-gallery-thumb]');

    thumbs.forEach(function (thumb) {
      if (!bindOnce(thumb)) return;

      thumb.addEventListener('click', function () {
        var main = document.getElementById(thumb.dataset.galleryThumb);
        if (!main) return;

        var image = main.querySelector('img');
        if (image) {
          /* srcset temizlenmezse tarayıcı eski görseli göstermeye devam eder */
          image.removeAttribute('srcset');
          image.removeAttribute('sizes');
          image.src = thumb.dataset.full;
        }

        thumbs.forEach(function (other) {
          if (other.dataset.galleryThumb === thumb.dataset.galleryThumb) {
            other.setAttribute('aria-current', 'false');
          }
        });
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* Güven şeridi kaydırma okları */
  function initTrustNav() {
    document.querySelectorAll('[data-trust-prev], [data-trust-next]').forEach(function (button) {
      if (!bindOnce(button)) return;

      var isNext = button.hasAttribute('data-trust-next');
      var trackId = isNext ? button.dataset.trustNext : button.dataset.trustPrev;

      button.addEventListener('click', function () {
        var track = document.getElementById(trackId);
        if (!track) return;
        var step = track.clientWidth * 0.8;
        track.scrollBy({ left: isNext ? step : -step, behavior: 'smooth' });
      });
    });
  }

  function init() {
    initTrustNav();
    initVariantPickers();
    initOptionPickers();
    initGallery();
  }

  if (document.readyState !== 'loading') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }

  /* Tema düzenleyicide bölüm yeniden yüklendiğinde olayları tekrar bağla */
  document.addEventListener('shopify:section:load', init);
})();
